import { LOGIN_INFO } from './constants'
import React from 'react'
import styled from 'styled-components'

const LoginButtonStyle = styled.a`
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, .12), 0 0 40px 0 rgba(72, 220, 255, .22);
  color: #fff;
  text-align: center;
  font-size: 16px;
  line-height: 40px;
  font-weight: 700;
  border: 1px solid #FFFFFF;
  border-radius: 8px;
  margin-right: 24px;
  height: 40px;
  width: 80px;

  &:hover {
    background: rgba(33, 197, 229, 0.2);
    transition: .2s ease-in-out;
  }

  @media (min-width: 992px) {
    width: 110px;
  }
`

const LoginButton = () => (
  <LoginButtonStyle
    className="login-button__desktop"
    href={ LOGIN_INFO.path }
  >
    { LOGIN_INFO.text }
  </LoginButtonStyle>
)

export default LoginButton
